// extracted by mini-css-extract-plugin
export default {"root":"MYmWYL","icon-button":"o3iEsu","iconButton":"o3iEsu"};